export default "__VITE_ASSET__DwwL33lF__"